// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"2b26d851","160":"af14f035","208":"82b0cec3","293":"40f49957","516":"287f4302","519":"250fda6d","917":"ca369957","946":"942cba84"}[chunkId] + ".chunk.js";
};